/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import "@fortawesome/fontawesome-free/css/all.css";
import 'vue2-datepicker/index.css';
import '../css/application.css';
import 'pretty-checkbox/src/pretty-checkbox.scss';
import 'vue-toast-notification/dist/theme-sugar.css';
import 'vue-js-modal/dist/styles.css'
import 'vue-select/dist/vue-select.css';

console.log('Selamat pagi!');
